import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchStacksSuggestionsArgs, SearchSuggestionsPossibleValuesString } from "types/generated";

type NewStackSearchStacksSuggestionsData = {
  searchStacksSuggestions: {
    fields: {
      possibleValuesString: Pick<
        SearchSuggestionsPossibleValuesString,
        "values" | "counts"
      > | null;
    }[];
  };
};

export const SEARCH_STACK_NAME_SUGGESTIONS: TypedDocumentNode<
  NewStackSearchStacksSuggestionsData,
  QuerySearchStacksSuggestionsArgs
> = gql`
  query NewStackSearchStacksSuggestions($input: SearchSuggestionsInput!) {
    searchStacksSuggestions(input: $input) {
      fields {
        possibleValuesString {
          values
          counts
        }
      }
    }
  }
`;
